import { AcCardQuestTh } from './common.interface';
import store from '@/store/index';
import subjects from '@/store/modules/subjects';
import { THSObj, xTHsMap } from '@/subjects/constant'
//@ts-ignore
let state = store.state.card;

/**
 * 只有自制情况下才需要存这些字段
 * @param roughcastSubjects 
 * @param options 
 */
export function stringifyJsonForSubjects(roughcastSubjects: Array<AcCardQuestTh>,options: any): any {
   let result:any = [];
   
   state.subjects.forEach((subject: any,index: number) => {
     // 这里可以不需要通过大题类型去找对应acCardQuestTh原始数据，可以直接通过下标找
        const roughcastSubject = stringifyJsonForSubject(roughcastSubjects[index], subject,options);
        result.push(roughcastSubject)
      });
      return result;
}


/**
 * 客观题
 * @param roughcastSubject 
 * @param subject 
 */
function stringifyJsonForSubject (roughcastSubject: any,subject: any,options: any): AcCardQuestTh {
  const { guid } = options;
  roughcastSubject = roughcastSubject || {};

  roughcastSubject = {
    ...roughcastSubject,
    questTh_name: subject.name,
    questTh: subject.th,
    questTh_operation: 1, // 新增和修改都为1 代表修改过题型
    fkCardGuid: guid, // 试题guid必传
    questTh_type: subject.type == 1 ? 2 : (subject.type == 2 ? 1 : subject.type)
  }
  roughcastSubject.quest_list && roughcastSubject.quest_list.length && (roughcastSubject.quest_list = roughcastSubject.quest_list.filter((item: any,index: number) => {
    return subject.items[index] && (subject.items[index].th ==item.quest_th)
  }))
  subject.items.forEach((item: any,index: number) => {
    if(!roughcastSubject.quest_list) {
      roughcastSubject.quest_list = [];
      !roughcastSubject.quest_list[index] && roughcastSubject.quest_list.push({
        quest_sechth: '1.1',
        quest_score: 0,
        quest_bfscore: 0,
        quest_option: 4,
        quest_blank: 1,
        quest_sort: 7, // quest_sort 小题类型：7-单选；8-多选；9-判断
    });
    }
    const XTh = item.xth || '';
    const DTh = THSObj[subject.th];
    const Th =  item.no;
    roughcastSubject.quest_list[index] = {
      ...roughcastSubject.quest_list[index],
      quest_score:item.score || subject.totalScore || 0,
      quest_bfscore:item.partScore || 0,
      quest_option:item.optionNum || 0,
      quest_sechth:`${DTh}.${Th}${XTh ? ('.' + (xTHsMap[XTh] || XTh)) : XTh}`,
      quest_sort: item.tType == 1 ? 7 : (item.tType == 2 ? 8 : 9),
      quest_blank: item.tCount || 0,
      quest_th: subject.th
    }
  });
  return roughcastSubject;
}

/**
 * 填空题
 * @param roughcastSubject 
 * @param subject 
 */
function stringifyJsonForBlank (roughcastSubject: AcCardQuestTh,subject: any): any {
  roughcastSubject.questTh_name = subject.name;
  roughcastSubject.questTh = subject.th;
}

